<template>
  <div class="store-visit">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.visitSellIn')">
    </NavHeaderBar>
    <div class="visit-form-content">
      <div class="form-item form-time-item">
        <div class="label required">
          <span class="alone-font">{{ $t('form.visitDate') }}</span>
        </div>
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :disabled="true"
          :value="visitForm.visitTime"
          placeholder=""
          @click="handleCalendar"
          :border="false"
          class="custom-field"
        >
          <template #left-icon>
            <van-icon name="calendar-o" color="#b9cbed" />
          </template>
        </van-field>
        <van-popup v-model="showCalendar" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :title="$t('form.chooseDate')"
            :max-date="maxDate"
            @confirm="onConfirmDate"
            @cancel="showCalendar = false"
          />
        </van-popup>
      </div>
      <div class="form-item uploader-customer">
        <div class="label required">
          <span class="alone-font">{{ $t('form.checkInPhoto') }}</span>
        </div>
        <van-uploader v-model="visitForm.imgMap.check" max-count="1" :after-read="(files, detail) => afterRead(files, detail, 'check')" />
      </div>
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="$t('form.listingStatus')" name="1">
          <template #title>
            <div><span class="collapse-title-reuqired">*</span>{{ $t('form.listingStatus') }}</div>
          </template>
          <div class="collapse-sub">
            <div class="sub-top">
              <div class="left-title">{{ $t('form.currentProductListingStatus') }}</div>
            </div>
            <div class="sub-bottom">
              <div class="sub-listing-item">{{ $t('form.listing') }} {{ shelfInfo.listing }}</div>
              <div class="sub-listing-item not-listing-item">{{ $t('form.notListing') }} {{ shelfInfo.notListing }}</div>
              <div class="sub-listing-item end-listing-item">{{ $t('form.endOfSales') }} {{ shelfInfo.endSales }}</div>
              <div class="sub-listing-item unknown-listing-item">{{ $t('shared.filter.unknown') }} {{ shelfInfo.unknown }}</div>
            </div>
            <div class="to-detail" @click="toUrl(`/shared/shelfStatus?customerId=${visitForm.customerId}`)">{{ $t('form.listingStatus') }}></div>
          </div>
          <div class="form-item listing-form-item" :class="{'no-listing-form-item': !visitForm.isUpdateShelf}">
            <div class="label">
              <span>{{ $t('shared.titleThirtyThree') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field shelf-radio">
              <template #input>
                <van-radio-group v-model="visitForm.isUpdateShelf" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in isUpdateShelfList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div v-show="visitForm.isUpdateShelf" class="shelf-title">{{ $t('form.selectProductsToUpdateListingStatus') }}：</div>
          <div v-show="visitForm.isUpdateShelf" class="shelf-bc">
            <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.shelfList" :key="brandItem.projectId">
              <div class="label square">
                <span>{{ brandItem.projectName }}</span>
              </div>
              <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                <div class="product-status">
                  <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions.shelfList(brandIndex, subItem.productId, brandItem.projectId)" :placeholder="$t('tips.pleaseSelectProduct')" :fieldNames="{label: 'productName', value: 'id'}" />
                  <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
                </div>
                <div class="product-listing">
                  <div class="listing-item">
                    <div class="listing-label">{{ $t('form.listingOrNot') }}</div>
                    <van-field class="custom-field custom-radio-field">
                      <template #input>
                        <van-radio-group v-model="subItem.isShelf" direction="horizontal">
                          <van-radio v-for="(subItem, subIndex) in isShelfList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                        </van-radio-group>
                      </template>
                    </van-field>
                  </div>
                  <div v-if="subItem.isShelf === 1">
                    <div class="listing-title">{{ $t('form.wayOfList') }}：</div>
                    <div class="listing-product" v-for="(checkItem, checkIndex) in subItem.detailList" :key="checkIndex">
                      <div class="checkout-custom">
                        <van-checkbox v-model="checkItem.isChoose" shape="square">{{ checkItem.type }}</van-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-more" @click="handleAdd('shelfList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
              <template v-if="brandSdMap[brandItem.projectId]">
                <div class="subset-form-item">
                  <div class="label required">
                    <span>{{ $t('shared.distributor') }}</span>
                  </div>
                  <div class="select-field custom-field" @click="toSelectStoreSd('shelfList', brandItem)">
                    {{ brandItem.expandInfo.sdList.map(item => item.sdName).join(',') }}
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">
                    <span>{{ $t('form.otherDistributor') }}</span>
                  </div>
                  <van-field v-model="brandItem.expandInfo.otherSd" placeholder="" :border="false" class="custom-field" />
                </div>
              </template>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.sellInByMyselfThisTime')" name="2">
          <div class="form-item">
            <div class="label order-type-label">
              <span>{{ $t('form.directOrNot') }}：</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group :value="visitForm.expandOrder.isDirect" direction="horizontal">
                  <van-radio :name="false" @click="() => handleOper(false, 'isDirect', 'expandOrder')">{{ $t('form.sellInFromDistributor') }}</van-radio>
                  <van-radio v-if="checkPer(['admin', 'app:expand:direct'])" :name="true" @click="() => handleOper(true, 'isDirect', 'expandOrder')">{{ $t('form.sellInFromAcmefog') }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div v-if="![null, ''].includes(visitForm.expandOrder.isDirect)">
            <div class="form-item">
              <div class="label order-type-label">
                <span>{{ $t('form.firstTimeOrNot') }}：</span>
              </div>
              <van-field class="custom-field custom-radio-field">
                <template #input>
                  <van-radio-group v-model="visitForm.expandOrder.firstOrder" direction="horizontal">
                    <van-radio :name="1">{{ $t('form.firistOrder') }}</van-radio>
                    <van-radio :name="0">{{ $t('form.reorder') }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
            <div v-if="visitForm.expandOrder.isDirect">
              <div class="sub-title">
                <div class="top-title">
                  <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
                  <div style="color: #317bff;">{{ $t('form.quantitySoldPcs') }}</div>
                </div>
                <div class="total-right">{{ $t('form.total') }} <span class="pcs-num">{{ totalProductQuantity }}</span> {{ $t('form.pcs') }}</div>
              </div>
              <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.expandOrder.productList" :key="brandIndex">
                <div class="label square">
                  <span>{{ brandItem.projectName }}</span>
                </div>
                <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                  <div class="product-status">
                    <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions.productList(brandIndex, subItem.productId, brandItem.projectId)" :placeholder="$t('tips.pleaseSelectProduct')" :fieldNames="{label: 'productName', value: 'id'}" @input="(val) => handelSelect(val, subItem)" />
                    <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
                  </div>
                  <div class="product-listing is-Direct" v-if="subItem.specList && subItem.specList.length > 0">
                    <van-collapse v-model="subItem.activeNames">
                      <van-collapse-item title="" name="1">
                        <template #title>
                          <div class="collapse-title">
                            <div>{{ $t('form.orderSalesVolume') }}：<span class="pcs-num" v-if="subItem.specList">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</div>
                          </div>
                        </template>
                        <div class="quantity-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                          <div class="title van-ellipsis">{{ specItem.specName }}</div>
                          <div class="stepper-custom">
                            <div class="step-btn" @click="handleStep(-5, specItem, 'quantity')">-5</div>
                            <div class="step-btn" @click="handleStep(-1, specItem, 'quantity')">-</div>
                            <van-field class="step-value" v-model.number="specItem.quantity" type="digit" :border="false" />
                            <div class="step-btn" @click="handleStep(1, specItem, 'quantity')">+</div>
                            <div class="step-btn" @click="handleStep(5, specItem, 'quantity')">+5</div>
                          </div>
                        </div>
                      </van-collapse-item>
                    </van-collapse>
                  </div>
                </div>
                <div class="add-more" @click="handleAdd('productList', brandItem)">+ {{ $t('button.addMoreProductForOrder') }}</div>
              </div>
              <div class="sub-title">
                <div class="top-title">
                  <img class="ell-icon" src="@/assets/images/ell_custom_icon.png" alt="">
                  <div class="left-desc" style="color: #808000;">{{ $t('form.quantityGivenAwayPcs') }}</div>
                </div>
                <div class="total-right">{{ $t('form.total') }} <span class="pcs-num" style="color: #808000;">{{ totalGiveProductQuantity }}</span> {{ $t('form.pcs') }}</div>
              </div>
              <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.expandOrder.giveProductList" :key="brandIndex + '1'">
                <div class="label custom-label square">
                  <span>{{ brandItem.projectName }}</span>
                </div>
                <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                  <div class="product-status">
                    <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions.giveProductList(brandIndex, subItem.productId, brandItem.projectId)" :placeholder="$t('tips.pleaseSelectProduct')" :fieldNames="{label: 'productName', value: 'id'}" @input="(val) => handelSelect(val, subItem)" />
                    <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
                  </div>
                  <div class="product-listing is-Direct" v-if="subItem.specList && subItem.specList.length > 0">
                    <van-collapse v-model="subItem.activeNames">
                      <van-collapse-item title="" name="1">
                        <template #title>
                          <div class="collapse-title">
                            <div>{{ $t('form.orderGiftVolume') }}：<span class="pcs-num" v-if="subItem.specList" style="color: #808000;">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</div>
                          </div>
                        </template>
                        <div class="quantity-item custom-quantity-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                          <div class="title van-ellipsis">{{ specItem.specName }}</div>
                          <div class="stepper-custom">
                            <div class="step-btn" @click="handleStep(-5, specItem, 'quantity')">-5</div>
                            <div class="step-btn" @click="handleStep(-1, specItem, 'quantity')">-</div>
                            <van-field class="step-value" v-model.number="specItem.quantity" type="digit" :border="false" />
                            <div class="step-btn" @click="handleStep(1, specItem, 'quantity')">+</div>
                            <div class="step-btn" @click="handleStep(5, specItem, 'quantity')">+5</div>
                          </div>
                        </div>
                      </van-collapse-item>
                    </van-collapse>
                  </div>
                </div>
                <div class="add-more custom-add-more" @click="handleAdd('giveProductList', brandItem)">+ {{ $t('button.addMoreProductForGiving') }}</div>
              </div>
            </div>
            <div v-else>
              <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.expandOrder.reorderList" :key="brandIndex">
                <div class="label square">
                  <span>{{ brandItem.projectName }}</span>
                </div>
                <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                  <div class="product-status">
                    <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions.reorderList(brandIndex, subItem.productId, brandItem.projectId)" :placeholder="$t('tips.pleaseSelectProduct')" :fieldNames="{label: 'productName', value: 'id'}" />
                    <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
                  </div>
                  <div class="product-listing">
                    <div class="listing-product">
                      <div class="checkout-custom">
                        <div>{{ $t('form.totalSellIn') }}：<span class="total-pcs">{{ calculateNum(subItem.quantity, subItem.giveQuantity) }}</span> {{ $t('form.pcs') }}</div>
                      </div>
                      <div class="quantity-item">
                        <div class="title">{{ $t('form.quantitySoldPcs') }}</div>
                        <div class="stepper-custom">
                          <div class="step-btn" @click="handleStep(-5, subItem, 'quantity')">-5</div>
                          <div class="step-btn" @click="handleStep(-1, subItem, 'quantity')">-</div>
                          <van-field class="step-value" v-model.number="subItem.quantity" type="digit" :border="false" />
                          <div class="step-btn" @click="handleStep(1, subItem, 'quantity')">+</div>
                          <div class="step-btn" @click="handleStep(5, subItem, 'quantity')">+5</div>
                        </div>
                      </div>
                      <div class="quantity-item">
                        <div class="title">{{ $t('form.quantityGivenAwayPcs') }}</div>
                        <div class="stepper-custom">
                          <div class="step-btn" @click="handleStep(-5, subItem, 'giveQuantity')">-5</div>
                          <div class="step-btn" @click="handleStep(-1, subItem, 'giveQuantity')">-</div>
                          <van-field class="step-value" v-model.number="subItem.giveQuantity" type="digit" :border="false" />
                          <div class="step-btn" @click="handleStep(1, subItem, 'giveQuantity')">+</div>
                          <div class="step-btn" @click="handleStep(5, subItem, 'giveQuantity')">+5</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="add-more" @click="handleAdd('reorderList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
                <template v-if="brandReorderSdMap[brandItem.projectId]">
                  <div class="subset-form-item">
                    <div class="label required">
                      <span>{{ $t('shared.distributor') }}</span>
                    </div>
                    <div class="select-field custom-field" @click="toSelectStoreSd('reorderList', brandItem)">
                      {{ brandItem.expandInfo.sdList.map(item => item.sdName).join(',') }}
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="label">
                      <span>{{ $t('form.otherDistributor') }}</span>
                    </div>
                    <van-field v-model="brandItem.expandInfo.otherSd" placeholder="" :border="false" class="custom-field" />
                  </div>
                </template>
              </div>
            </div>
            <div v-if="visitForm.expandOrder.isDirect">
              <!-- <div class="form-item">
                <div class="label required">Order Type</div>
                <XuSelect v-model="visitForm.expandOrder.orderType" :dataOptions="orderTypeList" />
              </div> -->
              <div class="form-item">
                <div class="label required">{{ $t('form.paymentType') }}</div>
                <XuSelect v-model="visitForm.expandOrder.paymentType" :dataOptions="globalData.payType" />
              </div>
              <div class="form-item">
                <div class="label required">
                  <span>{{ $t('form.paymentStatus') }}</span>
                </div>
                <van-field class="custom-field custom-radio-field">
                  <template #input>
                    <van-radio-group v-model="visitForm.expandOrder.paymentStatus" direction="horizontal">
                      <van-radio name="Paid">{{ $t('form.paid') }}</van-radio>
                      <van-radio name="Unpaid">{{ $t('form.unpaid') }}</van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
              </div>
              <div class="form-item">
                <div class="label required">
                  <span>{{ $t('form.tax') }}</span>
                </div>
                <van-field class="custom-field custom-radio-field">
                  <template #input>
                    <van-radio-group v-model="visitForm.expandOrder.taxType" direction="horizontal">
                      <van-radio name="Tax Inclusive">{{ $t('form.taxInclusive') }}</van-radio>
                      <van-radio name="Tax Exclusive">{{ $t('form.taxExclusive') }}</van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
              </div>
            </div>
            <div class="form-item">
              <div class="label square">
                <span>{{ $t('form.pOOrder') }}</span>
              </div>
              <van-uploader v-model="visitForm.imgMap.poOrder" :after-read="(files, detail) => afterRead(files, detail, 'poOrder')" />
            </div>
            <div class="form-item">
              <div class="label square">
                <span>{{ $t('form.receipt') }}</span>
              </div>
              <van-uploader v-model="visitForm.imgMap.receipt" :after-read="(files, detail) => afterRead(files, detail, 'receipt')" />
            </div>
            <div class="form-item">
              <div class="label square">
                <span>{{ $t('form.productCashCheque') }}</span>
              </div>
              <van-uploader v-model="visitForm.imgMap.productCashOrCheque" :after-read="(files, detail) => afterRead(files, detail, 'productCashOrCheque')" />
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.materialSampleDelivery')" name="3">
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.sampleDelivery') }}</span>
            </div>
            <div class="sample-delivry">
              <div class="main-header">
                <div class="left-header">
                  <span>{{ $t('form.total') }} </span>
                  <span class="total-num">{{ sampleListTotal }} </span>
                  <span>{{ $t('form.pcs') }}</span>
                </div>
                <div class="sell-out-btn" @click="toSelectSample">+ {{ $t('button.select') }}</div>
              </div>
              <div class="promotion-item" v-for="subItem in sampleList" :key="subItem.productId">
                <img v-if="subItem.imgUrl" class="icon-img" :src="subItem.imgUrl" alt="">
                <img v-else class="icon-img" src="@/assets/images/icon_noimg.png" alt="">
                <div class="right-content">
                  <div class="info-item">
                    <div class="product-info">
                      <span class="product-name txt-ellipsis">{{ subItem.projectName }}·{{ subItem.productName }}</span>
                      <!-- <van-icon v-if="subItem.isMain === 1" name="star" color="#e0bc38" /> -->
                    </div>
                    <div class="material-inventory">
                      <span class="inventory-num txt-ellipsis">{{ $t('form.inv') }}：{{ subItem.inventoryCount }}</span>
                    </div>
                  </div>
                  <div class="stepper-custom">
                    <div class="step-btn" @click="handleStep(-5, subItem, 'quantity', { checkInventory: true })">-5</div>
                    <div class="step-btn" @click="handleStep(-1, subItem, 'quantity', { checkInventory: true })">-</div>
                    <van-field class="step-value" v-model.number="subItem.quantity" type="digit" :border="false" @blur="handleQuantityInputBlur(subItem)" />
                    <div class="step-btn" @click="handleStep(1, subItem, 'quantity', { checkInventory: true })">+</div>
                    <div class="step-btn" @click="handleStep(5, subItem, 'quantity', { checkInventory: true })">+5</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.materialDelivery') }}</span>
            </div>
            <div class="material-delivery">
            <div class="main-header">
              <div class="left-header">
                <span>{{ $t('form.total') }} </span>
                <span class="total-num">{{ materialListTotal }} </span>
                <span>{{ $t('form.pcs') }}</span>
              </div>
              <div class="sell-out-btn" @click="toSelectMaterial">+ {{ $t('button.select') }}</div>
            </div>
            <div class="promotion-item" v-for="subItem in materialList" :key="subItem.id">
              <img v-if="subItem.imgUrl" class="icon-img" :src="subItem.imgUrl" alt="">
              <img v-else class="icon-img" src="@/assets/images/icon_noimg.png" alt="">
              <div class="right-content">
                <div class="info-item">
                  <div class="product-info">
                    <span class="product-name txt-ellipsis">{{ subItem.materielName }}</span>
                    <van-icon v-if="subItem.isMain === 1" name="star" color="#e0bc38" />
                  </div>
                  <div class="material-inventory">
                    <div class="product-name-item" v-if="subItem.materielType === 1">
                      <div class="project-name universal-name">{{ subItem.projectName }}</div>
                      <div class="inventory-num">{{ $t('form.inv') }}: {{ subItem.inventoryCount }}</div>
                    </div>
                    <div class="product-name-item" v-else>
                      <div class="project-name" v-for="proItem in subItem.productName.split(',')" :key="proItem">{{ proItem }}</div>
                      <div class="inventory-num">{{ $t('form.inv') }}: {{ subItem.inventoryCount }}</div>
                    </div>
                  </div>
                </div>
                <div class="stepper-custom">
                  <div class="step-btn" @click="handleStep(-5, subItem, 'quantity', { checkInventory: true })">-5</div>
                  <div class="step-btn" @click="handleStep(-1, subItem, 'quantity', { checkInventory: true })">-</div>
                  <van-field class="step-value" v-model.number="subItem.quantity" type="digit" :border="false" @blur="handleQuantityInputBlur(subItem)" />
                  <div class="step-btn" @click="handleStep(1, subItem, 'quantity', { checkInventory: true })">+</div>
                  <div class="step-btn" @click="handleStep(5, subItem, 'quantity', { checkInventory: true })">+5</div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.materialSamplePhoto') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.deliveryMaterialProto" :after-read="(files, detail) => afterRead(files, detail, 'deliveryMaterialProto')" />
          </div>
        </van-collapse-item>
        <van-collapse-item v-if="checkPer(['admin', 'app:expand:invitationKos'])" :title="$t('form.kOSGroupInvitation')" name="4">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.staffName') }}</span>
            </div>
            <van-field v-model="visitForm.invite.staffName" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.kOSGroupJoinScreenshot') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.inviteUrl" :after-read="(files, detail) => afterRead(files, detail, 'inviteUrl')" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.recommendationsEventInvitations')" name="5">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.isItRecommendedForRoutineOperation') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="visitForm.isCommend" direction="horizontal">
                  <van-radio :name="1">{{ $t('shared.filter.yes') }}</van-radio>
                  <van-radio :name="0">{{ $t('shared.filter.no') }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="form-item" v-if="visitForm.isCommend === 1">
            <div class="label">
              <span>{{ $t('form.isThereAnInvitationForAnEvent') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="visitForm.visitEvent.isEvent" direction="horizontal">
                  <van-radio :name="1">{{ $t('shared.filter.yes') }}</van-radio>
                  <van-radio :name="0">{{ $t('shared.filter.no') }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div v-if="visitForm.visitEvent.isEvent == 1 && visitForm.isCommend === 1">
            <div class="form-item">
              <div class="label">
                <span>{{ $t('form.eventStoreContactName') }}</span>
              </div>
              <van-field v-model="visitForm.visitEvent.contactName" placeholder="" :border="false" class="custom-field" />
            </div>
            <div class="form-item">
              <div class="label">
                <span>{{ $t('form.contactPosition') }}</span>
              </div>
              <XuSelect v-model="visitForm.visitEvent.job" :dataOptions="jobList" />
            </div>
            <div class="form-item">
              <div class="label">
                <span>{{ $t('form.phone') }}</span>
              </div>
              <van-field v-model="visitForm.visitEvent.contactPhone" type="number" placeholder="" :border="false" class="custom-field" />
            </div>
            <div class="form-item">
              <div class="label">
                <span>{{ $t('form.expectedTime') }}</span>
              </div>
              <XuSelect v-model="visitForm.visitEvent.expectedTime" :dataOptions="timeList" />
            </div>
            <div class="form-item">
              <div class="label">
                <span>{{ $t('form.notes') }}</span>
              </div>
              <van-field v-model="visitForm.visitEvent.note" placeholder="" :border="false" class="custom-field" />
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('shared.feedback')" name="6">
          <div class="form-item">
            <div class="label">
              <span></span>
            </div>
            <van-field v-model="visitForm.feedback" type="textarea" show-word-limit rows="3" placeholder="" class="custom-field field-textarea" />
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="visit-btn">
      <van-button class="submit-btn" @click="handleSubmit" :loading="isLoading" :loading-text="$t('button.submit')">{{ $t('button.submit') }}</van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { Toast, Dialog } from 'vant'
import { calculateAdd } from '@/utils/math'
import { arsVisitAddOrUpdateApi, arsVisitInfoApi } from '@/api/visit'
import { arsProjectAppQueryListApi } from '@/api/storeMaintain'
import { customerShelfGeneralApi, homeCurrentTimeApi } from '@/api/shared'
const copyVisitForm = {
  id: '',
  customerId: '',
  lng: '',
  lat: '',
  inputAddress: '',
  visitTime: '', // moment(new Date()).format('YYYY-MM-DD'),
  isUpdateShelf: true,
  isCommend: 0,
  feedback: '',
  expandOrder: {
    firstOrder: 0,
    isDirect: '',
    // orderType: '',
    paymentType: '',
    paymentStatus: '',
    taxType: '',
    reorderList: [],
    productList: [],
    giveProductList: []
  },
  visitEvent: {
    isEvent: '',
    contactName: '',
    contactPhone: '',
    job: '',
    expectedTime: '',
    note: ''
  },
  invite: {
    staffName: ''
  },
  imgMap: {
    check: [],
    poOrder: [],
    receipt: [],
    productCashOrCheque: [],
    deliveryMaterialProto: [],
    inviteUrl: []
  },
  shelfList: []
}
export default {
  components: {
    XuSelect: () => import('@/components/XuSelect')
  },
  data () {
    return {
      activeNames: [],
      showCalendar: false,
      currentDate: new Date(),
      visitForm: {
        id: '',
        customerId: '',
        lng: '',
        lat: '',
        inputAddress: '',
        visitTime: '',
        isUpdateShelf: true,
        isCommend: 0,
        feedback: '',
        expandOrder: {
          firstOrder: 0,
          isDirect: '',
          // orderType: '',
          paymentType: '',
          paymentStatus: '',
          taxType: '',
          reorderList: [],
          productList: [],
          giveProductList: []
        },
        visitEvent: {
          isEvent: '',
          contactName: '',
          contactPhone: '',
          job: '',
          expectedTime: '',
          note: ''
        },
        invite: {
          staffName: ''
        },
        imgMap: {
          check: [],
          poOrder: [],
          receipt: [],
          productCashOrCheque: [],
          deliveryMaterialProto: [],
          inviteUrl: []
        },
        shelfList: []
      },
      isShelfList: [
        { label: this.$t('form.listing'), value: 1 },
        { label: this.$t('form.notListing'), value: 0 },
        { label: this.$t('form.endOfSales'), value: -1 }
      ],
      radioList: [
        { label: this.$t('shared.filter.yes'), value: true },
        { label: this.$t('shared.filter.no'), value: false }
      ],
      isUpdateShelfList: [
        { label: `${this.$t('shared.filter.needTo')}.`, value: true },
        { label: `${this.$t('shared.filter.notNeedTo')}.`, value: false }
      ],
      copyDetailList: [],
      maxDate: new Date(),
      materialList: [],
      sampleList: [],
      jobList: [],
      timeList: [
        // 一周内
        { label: this.$t('shared.filter.inWeek'), value: 'In a week' },
        // 两周内
        { label: this.$t('shared.filter.inTwoWeeks'), value: 'In two weeks' },
        // 一个月内
        { label: this.$t('shared.filter.inMonth'), value: 'In a month' }
      ],
      isLoading: false,
      shelfInfo: {}
    }
  },
  watch: {},
  activated () {
    if (this.isNavigatingToSelect) {
      const materialDelivery = JSON.parse(window.localStorage.getItem('materialDelivery'))
      if (materialDelivery) {
        this.materialList = materialDelivery
        window.localStorage.removeItem('materialDelivery')
      }
    } else if (this.isNavigateToSampleSelect) {
      const sampleDelivery = JSON.parse(window.localStorage.getItem('sampleDelivery'))
      if (sampleDelivery) {
        this.sampleList = sampleDelivery
        window.localStorage.removeItem('sampleDelivery')
      }
    } else if (this.isNavigateToSdSelect) {
      const sdStoreSelect = JSON.parse(window.localStorage.getItem('sdStoreSelect'))
      if (sdStoreSelect) {
        const currentBrandList = ['reorderList'].includes(sdStoreSelect.typeKey) ? this.visitForm.expandOrder[sdStoreSelect.typeKey] : this.visitForm[sdStoreSelect.typeKey]
        currentBrandList.find(subItem => {
          if (subItem.projectId === sdStoreSelect.brandId) {
            subItem.expandInfo.sdList = sdStoreSelect.typeValue
            return subItem
          }
        })
        window.localStorage.removeItem('sdStoreSelect')
      }
    } else if (this.isNavigateToShelf) {

    } else {
      this.activeNames = []
      this.visitForm = JSON.parse(JSON.stringify(copyVisitForm))
      this.materialList = []
      this.sampleList = []
      const { visitId = '', customerId = '' } = this.$route.query
      this.visitForm.id = visitId
      this.visitForm.customerId = customerId
      this.echoData()
      this.initData()
    }
    this.isNavigatingToSelect = false
    this.isNavigateToSampleSelect = false
    this.isNavigateToSdSelect = false
    this.isNavigateToShelf = false
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    brandSdMap () {
      const map = {}
      if (!this.visitForm.shelfList) return map
      this.visitForm.shelfList.forEach(brandItem => {
        map[brandItem.projectId] = brandItem.productList.some(subItem => {
          return subItem.productId && subItem.isShelf === 1 && subItem.detailList.some(detItem => detItem.type === 'Product On-sell(Distributor)' && detItem.isChoose)
        })
      })
      return map
    },
    brandReorderSdMap () {
      const map = {}
      if (!this.visitForm.expandOrder.reorderList) return map
      this.visitForm.expandOrder.reorderList.forEach(brandItem => {
        map[brandItem.projectId] = brandItem.productList.some(subItem => {
          return subItem.productId
        })
      })
      return map
    },
    materialListTotal () {
      return this.materialList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    sampleListTotal () {
      return this.sampleList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    totalProductQuantity () {
      if (!this.visitForm.expandOrder || !this.visitForm.expandOrder.productList) {
        return 0
      }
      return this.visitForm.expandOrder.productList.reduce((total, product) => {
        if (!product.productList) {
          return total
        }
        const productTotal = product.productList.reduce((productSum, subProduct) => {
          if (!subProduct.specList) {
            return productSum
          }
          const specTotal = subProduct.specList.reduce((subTotal, spec) => {
            return subTotal + (Number(spec.quantity) || 0)
          }, 0)
          return productSum + specTotal
        }, 0)
        return total + productTotal
      }, 0)
    },
    totalGiveProductQuantity () {
      if (!this.visitForm.expandOrder || !this.visitForm.expandOrder.giveProductList) {
        return 0
      }
      return this.visitForm.expandOrder.giveProductList.reduce((total, product) => {
        if (!product.productList) {
          return total
        }
        const productTotal = product.productList.reduce((productSum, subProduct) => {
          if (!subProduct.specList) {
            return productSum
          }
          const specTotal = subProduct.specList.reduce((subTotal, spec) => {
            return subTotal + (Number(spec.quantity) || 0)
          }, 0)
          return productSum + specTotal
        }, 0)
        return total + productTotal
      }, 0)
    },
    filteredOptions () {
      const result = {
        shelfList: {},
        productList: [],
        reorderList: [],
        giveProductList: []
      }
      if (!this.globalData.productList) return result

      // Helper function to get options excluding other selected IDs
      const getOptionsForList = (list, currentId = null, projectId = null) => {
        const selectedIds = list.map(item => item.productId).filter(id => id && id !== currentId)
        return this.globalData.productList.filter(item => {
          // If it's a shelfList, it must match the projectId
          if (projectId && item.projectId !== projectId) {
            return false
          }
          // Include if it's the current item's ID or if it's not selected by others
          return !selectedIds.includes(item.id)
        })
      }

      // We need to return a function that looks up the correct array so we can pass currentId
      return {
        shelfList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.shelfList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        },
        productList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.expandOrder.productList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        },
        giveProductList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.expandOrder.giveProductList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        },
        reorderList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.expandOrder.reorderList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path === '/selectMaterial') {
      this.isNavigatingToSelect = true
    } else if (to.path === '/shared/selectSample') {
      this.isNavigateToSampleSelect = true
    } else if (to.path === '/shared/selectStoreSd') {
      this.isNavigateToSdSelect = true
    } else if (to.path === '/shared/shelfStatus') {
      this.isNavigateToShelf = true
    }
    next()
  },
  methods: {
    handelSelect (currentVal, params) {
      const findData = this.globalData.productList.find(subItem => {
        if (subItem.id === currentVal) {
          return subItem
        }
      })
      if (findData) {
        const newSpecList = JSON.parse(JSON.stringify(findData.specList))
        newSpecList.forEach(subItem => {
          subItem.quantity = ''
        })
        this.$set(params, 'specList', newSpecList)
      }
    },
    handleCalendar () {
      // if (this.visitForm.id) return
      // this.showCalendar = true
    },
    handleAdd (type, params = {}) {
      const formeKey = params.productList
      const filterProduct = this.globalData.productList.filter(item => item.projectId === params.projectId)
      if (formeKey.length >= filterProduct.length) {
        Toast(this.$t('tips.noMoreProducts'))
        return
      }
      if (type === 'shelfList') {
        params.productList.push({
          productId: '',
          isShelf: '',
          detailList: JSON.parse(JSON.stringify(this.copyDetailList))
        })
      } else if (type === 'reorderList') {
        params.productList.push({
          productId: '',
          giveQuantity: '',
          quantity: ''
        })
      } else if (['productList', 'giveProductList'].includes(type)) {
        params.productList.push({
          productId: '',
          activeNames: ['1'],
          specList: []
        })
      }
    },
    handleDel (params, index) {
      Dialog.confirm({
        message: this.$t('tips.messageNine'),
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#c4200b'
      })
        .then(() => {
          params.productList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    initData () {
      this.copyDetailList = []
      this.globalData.shelfType.forEach(subItem => {
        // if (subItem.value === 'Product Sell-in(BA)')
        this.copyDetailList.push({ type: subItem.value, isChoose: false, quantity: '', giveQuantity: '' })
      })
      this.jobList = []
      this.globalData.customerJob.forEach(subItem => {
        this.jobList.push({ label: subItem.label, value: JSON.parse(subItem.value).val })
      })
      if (!this.visitForm.id) {
        const currentTimeLoc =
          JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
        this.visitForm.lat = currentTimeLoc.lat
        this.visitForm.lng = currentTimeLoc.lng
        if (!currentTimeLoc.lat) return
        // 根据经纬度获取位置
        this.$nextTick(() => {
          new google.maps.Geocoder().geocode(
            {
              location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
            },
            (results, status) => {
              // 这里处理结果和上面一模一样
              if (status === google.maps.GeocoderStatus.OK) {
                this.visitForm.inputAddress = results[0].formatted_address
              } else {
                console.log('：error ' + status)
              }
            }
          )
        })
      }
    },
    onConfirmDate (date) {
      this.visitForm.visitTime = moment(date).format('YYYY-MM-DD')
      this.showCalendar = false
    },
    handleSubmit () {
      if (!this.visitForm.visitTime) {
        Toast(this.$t('tips.messageThirtyThree'))
        return
      }
      if (this.handleChecked()) {
        return
      }
      this.isLoading = true
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const { imgMap, visitEvent, expandOrder } = this.visitForm
      const data = {
        ...this.visitForm,
        visitEvent: visitEvent,
        imgMap: {
          check: imgMap.check.map(subItem => subItem.url).join(','),
          poOrder: expandOrder.isDirect ? '' : imgMap.poOrder.map(subItem => subItem.url).join(','),
          receipt: expandOrder.isDirect ? '' : imgMap.receipt.map(subItem => subItem.url).join(','),
          productCashOrCheque: expandOrder.isDirect ? '' : imgMap.productCashOrCheque.map(subItem => subItem.url).join(','),
          directPoOrder: expandOrder.isDirect ? imgMap.poOrder.map(subItem => subItem.url).join(',') : '',
          directReceipt: expandOrder.isDirect ? imgMap.receipt.map(subItem => subItem.url).join(',') : '',
          directProductCashOrCheque: expandOrder.isDirect ? imgMap.productCashOrCheque.map(subItem => subItem.url).join(',') : '',
          deliveryMaterialProto: imgMap.deliveryMaterialProto.map(subItem => subItem.url).join(','),
          inviteUrl: imgMap.inviteUrl.map(subItem => subItem.url).join(',')
        },
        putMaterielList: this.materialList.map(subItem => { return { id: subItem.id, quantity: subItem.quantity } }),
        protoList: this.sampleList.map(subItem => { return { productId: subItem.productId, quantity: subItem.quantity } }),
        visitType: '1'
      }
      arsVisitAddOrUpdateApi(data).then(res => {
        Toast.clear()
        this.$router.go(-1)
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    imgFormat (arr) {
      let newArr = []
      if (arr.length > 0) {
        newArr = arr.split(',').map(subItem => {
          return { url: subItem }
        })
        return newArr
      } else {
        return []
      }
    },
    getlocation (lat, lng, toAddress) {},
    handleStep (delta, params, typeKey, obj = {}) {
      if (obj.checkInventory) {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        const newInventory = params.originalInventoryCount - newQuantity
        this.$set(params, typeKey, newQuantity)
        this.$set(params, 'inventoryCount', newInventory)
      } else {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        this.$set(params, typeKey, newQuantity)
      }
    },
    handleQuantityInputBlur (item) {
      let newQuantity = Number(item.quantity) || 0
      if (newQuantity < 0) {
        newQuantity = 0
        this.$set(item, 'quantity', 0)
      }
      const newInventory = item.originalInventoryCount - newQuantity
      this.$set(item, 'inventoryCount', newInventory)
    },

    handleChecked () {
      let isFlag = false

      if (this.visitForm.imgMap.check.length <= 0) {
        Toast(this.$t('tips.checkInPhotoIsRequired'))
        isFlag = true
      }

      if (isFlag) {
        return isFlag
      }
      let shelftipsSingle = ''
      let shelfFlag = false
      if (this.visitForm.isUpdateShelf) {
        this.visitForm.shelfList.find(brandItem => {
          shelftipsSingle = this.$t('tips.messageThirtyFour', { projectName: brandItem.projectName })
          if (brandItem.productList.length > 0) {
            shelfFlag = true
          }
          brandItem.productList.find(subItem => {
            if (!subItem.productId || (subItem.productId && subItem.isShelf === '')) {
              isFlag = true
              Toast(`${this.$t('form.listingStatus')} ${this.$t('tips.isRequired')}`)
              return subItem
            }
            if (subItem.productId && subItem.isShelf === 1) {
              let detFlag = true
              shelftipsSingle = `${this.$t('form.listingStatus')} ${this.$t('tips.isRequired')}`
              subItem.detailList.find(detItem => { // brandReorderSdMap[brandItem.projectId]
                if (this.checkPer(['admin', 'app:sd:visitInput']) && (detItem.isChoose && detItem.type === 'Product On-sell(Distributor)') && brandItem.expandInfo.sdList.length <= 0 && !brandItem.expandInfo.otherSd) {
                  shelftipsSingle = this.$t('tips.messageThirtyFour', { projectName: brandItem.projectName })
                  detFlag = true
                  return detItem
                } else if (detItem.isChoose) {
                  detFlag = false
                }
              })
              if (detFlag) {
                isFlag = detFlag
                Toast(shelftipsSingle)
                return subItem
              }
            }
          })
          if (isFlag) {
            return brandItem
          }
        })
        if (!shelfFlag) {
          Toast(`${this.$t('form.listingStatus')} ${this.$t('tips.isRequired')}`)
          isFlag = true
        }
      }
      if (!shelfFlag && isFlag) {
        return isFlag
      }
      if (this.visitForm.expandOrder.isDirect && !isFlag) {
        this.visitForm.expandOrder.productList.find(brandItem => {
          brandItem.productList.find(subItem => {
            if (!subItem.productId) {
              Toast(`${this.$t('form.quantitySoldPcs')} ${this.$t('tips.isRequired')}`)
              isFlag = true
              return subItem
            }
          })
          if (isFlag) {
            return brandItem
          }
        })
        if (isFlag) {
          return isFlag
        }
        this.visitForm.expandOrder.giveProductList.find(brandItem => {
          brandItem.productList.find(subItem => {
            if (!subItem.productId) {
              Toast(`${this.$t('form.quantityGivenAwayPcs')} ${this.$t('tips.isRequired')}`)
              isFlag = true
              return subItem
            }
          })
          if (isFlag) {
            return brandItem
          }
        })
        if (isFlag) {
          return isFlag
        }
        // 'orderType',
        const checkList = [
          { label: this.$t('form.paymentType'), value: 'paymentType' },
          { label: this.$t('form.paymentStatus'), value: 'paymentStatus' },
          { label: this.$t('form.tax'), value: 'taxType' }
        ]
        checkList.find(subItem => {
          if (this.visitForm.expandOrder[subItem.value] === '') {
            isFlag = true
            Toast(`${subItem.label} ${this.$t('tips.isRequired')}`)
            return subItem
          }
        })
      }

      if (!['', null].includes(this.visitForm.expandOrder.isDirect) && !this.visitForm.expandOrder.isDirect && !isFlag) {
        let tipsSingle = ''
        this.visitForm.expandOrder.reorderList.find(brandItem => {
          tipsSingle = this.$t('tips.messageThirtyFour', { projectName: brandItem.projectName })
          brandItem.productList.find(subItem => {
            if (!subItem.productId || (subItem.productId && this.calculateNum(subItem.quantity, subItem.giveQuantity) <= 0)) {
              isFlag = true
              Toast(!subItem.productId ? this.$t('tips.messageFortyTwo') : this.$t('tips.productIsRequired'))
              return subItem
            }
            if (this.checkPer(['admin', 'app:sd:visitInput']) && subItem.productId && brandItem.expandInfo.sdList.length <= 0 && !brandItem.expandInfo.otherSd) {
              isFlag = true
              Toast(tipsSingle)
              return subItem
            }
          })
          if (isFlag) {
            return brandItem
          }
        })
      }

      if (this.visitForm.isCommend === 1 && !isFlag) {
        let isPass = true
        if (this.visitForm.isUpdateShelf) {
          this.visitForm.shelfList.find(brandItem => {
            brandItem.productList.find(subItem => {
              if (subItem.productId && subItem.isShelf === 1) {
                let detFlag = false
                subItem.detailList.find(detItem => {
                  if (detItem.isChoose) {
                    detFlag = true
                    return detItem
                  }
                })
                if (detFlag) {
                  isPass = false
                  return subItem
                }
              }
            })
            if (!isPass) {
              return brandItem
            }
          })
        }
        // isPass = true
        if (this.visitForm.expandOrder.isDirect === false) {
          this.visitForm.expandOrder.reorderList.find(brandItem => {
            brandItem.productList.find(subItem => {
              if (subItem.productId && this.calculateNum(subItem.quantity, subItem.giveQuantity) > 0) {
                isPass = false
                return subItem
              }
            })
            if (!isPass) {
              return brandItem
            }
          })
        } else if (this.visitForm.expandOrder.isDirect === true && this.totalProductQuantity > 0) {
          isPass = false
        }
        if (isPass) {
          Toast(this.$t('tips.messageFortyThree'))
          isFlag = true
        }
      }

      return isFlag
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this.visitForm.imgMap[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          this.visitForm.imgMap[key].splice(detail.index, 1)
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    async echoData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      if (!this.visitForm.id) {
        arsProjectAppQueryListApi().then(res => {
          res.data.forEach(subItem => {
            this.visitForm.shelfList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [], expandInfo: { sdList: [], otherSd: '' } })
            this.visitForm.expandOrder.productList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [] })
            this.visitForm.expandOrder.giveProductList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [] })
            this.visitForm.expandOrder.reorderList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [], expandInfo: { sdList: [], otherSd: '' } })
          })
        })
        homeCurrentTimeApi().then(res => {
          this.visitForm.visitTime = moment(res.data).format('YYYY-MM-DD')
        })
      }
      if (this.visitForm.id) {
        const res = await arsVisitInfoApi(this.visitForm.id)
        Toast.clear()
        const { putMaterielList = [], expandOrder, protoList = [], shelfList } = res.data
        expandOrder.productList.forEach(brandItem => {
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
          })
        })
        expandOrder.giveProductList.forEach(brandItem => {
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
          })
        })
        shelfList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        expandOrder.reorderList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })

        Object.keys(this.visitForm).forEach(subItem => {
          if (subItem === 'imgMap') {
            this.visitForm[subItem].check = this.imgFormat(res.data[subItem].check)
            if (expandOrder && expandOrder.isDirect) {
              this.visitForm[subItem].poOrder = this.imgFormat(res.data[subItem].directPoOrder)
              this.visitForm[subItem].receipt = this.imgFormat(res.data[subItem].directReceipt)
              this.visitForm[subItem].productCashOrCheque = this.imgFormat(res.data[subItem].directProductCashOrCheque)
            } else {
              this.visitForm[subItem].poOrder = this.imgFormat(res.data[subItem].poOrder)
              this.visitForm[subItem].receipt = this.imgFormat(res.data[subItem].receipt)
              this.visitForm[subItem].productCashOrCheque = this.imgFormat(res.data[subItem].productCashOrCheque)
            }
            this.visitForm[subItem].deliveryMaterialProto = this.imgFormat(res.data[subItem].deliveryMaterialProto)
            this.visitForm[subItem].inviteUrl = this.imgFormat(res.data[subItem].inviteUrl)
          } else {
            this.visitForm[subItem] = res.data[subItem]
          }
        })
        putMaterielList.forEach(subItem => {
          subItem.isChoose = true
          subItem.originalInventoryCount = Number(subItem.inventoryCount) || 0
        })
        protoList.forEach(subItem => {
          subItem.isChoose = true
          subItem.originalInventoryCount = Number(subItem.inventoryCount) || 0
        })
        this.materialList = putMaterielList || []
        this.sampleList = protoList
      } else {
        Toast.clear()
      }
      customerShelfGeneralApi(this.visitForm.customerId).then(res => {
        this.shelfInfo = res.data || {}
      })
    },
    calculateNum (num1, num2) {
      return calculateAdd(num1, num2)
    },
    handleOper (val, type, parentType) {
      if (parentType) {
        if (this.visitForm[parentType][type] === val) {
          this.visitForm[parentType][type] = ''
        } else {
          this.visitForm[parentType][type] = val
        }
      } else {
        if (this.visitForm[type] === val) {
          this.visitForm[type] = ''
        } else {
          this.visitForm[type] = val
        }
      }
    },
    toSelectMaterial () {
      if (this.materialList.length > 0) {
        window.localStorage.setItem('materialDelivery', JSON.stringify(this.materialList))
      }
      this.$router.push('/selectMaterial?pageType=expandVisit')
    },
    toSelectSample () {
      if (this.sampleList.length > 0) {
        window.localStorage.setItem('sampleDelivery', JSON.stringify(this.sampleList))
      }
      this.$router.push('/shared/selectSample?pageType=expandVisit')
    },
    toSelectStoreSd (currKey, params) {
      window.localStorage.setItem('sdStoreSelect', JSON.stringify({ typeKey: currKey, typeValue: params.expandInfo.sdList || [], brandId: params.projectId }))
      this.$router.push('/shared/selectStoreSd')
    },
    toUrl (url) {
      if (!url) return
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.store-visit {
  // display: flex;
  // flex-direction: column;
  // height: 100%;
  .visit-form-content {
    // flex: 1;
    // overflow-y: auto;
    padding-bottom: 50px;
    /deep/.van-collapse {
      .van-collapse-item {
        background-color: #fff;
        .van-collapse-item__title {
          background-color: #e8effc;
          font-weight: bold;
          padding: 5px 10px;
          margin-bottom: 2px;
          .van-cell__title {
            font-weight: bold;
            > span {
              font-size: 14px;
            }
          }
        }
        .van-collapse-item__content {
          padding: 0px 10px;
          padding-top: 10px;
        }
      }
      &::after {
        border: none;
      }
    }
    .collapse-sub {
      padding: 8px 0;
      margin-bottom: 10px;
      // border-bottom: 1px solid #e8effc;
      .sub-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .left-title {
          color: #333;
          font-weight: bold;
        }
      }
      .sub-bottom {
        display: flex;
        flex-wrap: wrap;
        .sub-listing-item {
          padding: 3px 5px;
          margin-right: 5px;
          margin-bottom: 3px;
          color: #50ad34;
          background-color: rgba(80, 173, 52, .2);
          border-radius: 5px;
          font-size: 12px;
        }
        .not-listing-item {
          color: #e79d42;
          background-color: rgba(231, 157, 66, .2);
        }
        .end-listing-item {
          color: #C4200B;
          background-color: rgba(196, 32, 11, .2);
        }
        .unknown-listing-item {
          color: #333;
          background-color: rgba(51, 51, 51, .2);
        }
      }
      .to-detail {
        margin-top: 10px;
        color: #307bff;
      }
    }
    .form-item,
    .subset-form-item {
      // padding: 0 10px;
      margin-bottom: 20px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .custom-label {
        &.square {
          &::before {
            background-color: #808000;
          }
        }
      }
      .order-type-label {
        font-size: 13px;
      }
      .brand-item {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .product-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .custom-radio-field {
        padding: 0;
        font-size: 12px;
        border: none;
      }
      .product-quantity {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        .chiledren-label {
          margin-left: 16px;
          margin-right: 5px;
          font-size: 12px;
          color: #333;
        }
        .custom-xu-select {
          width: 166px;
        }
        .half-field {
          flex: 1;
        }
      }
      .product-sales {
        .product-mode {
          display: flex;
          align-items: center;
        }
        .mode-label {
          flex: 1;
          margin-right: 10px;
          font-size: 12px;
          color: #333;
          &::before {
            content: '#';
            width: 8px;
            height: 8px;
            color: #307bff;
            margin-right: 5px;
          }
        }
        .xu-custom-select {
          width: 210px;
        }
      }
      .del-img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
      .product-desc {
        margin: 10px 0;
        padding: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .quantity-form {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .quantity-form,
        .area-form {
          .form-label {
            font-size: 12px;
            color: #7f7f7f;
          }
        }
        .area-form {
          margin-top: 8px;
        }
      }
      .product-listing {
        padding: 10px;
        margin-top: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .listing-item {
          padding-bottom: 5px;
          border-bottom: 1px solid #ebedf0;
          .listing-label {
            margin-bottom: 5px;
            font-size: 12px;
            color: #333;
          }
          /deep/.van-cell {
            width: auto;
          }
          .custom-radio-field {
            background-color: #f7f7f7;
          }
        }
        .listing-title {
          margin-top: 10px;
          font-size: 13px;
          color: #7f7f7f;
        }
        .listing-product {
          .checkout-custom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            font-size: 12px;
            color: #7f7f7f;
            /deep/.van-checkbox__label {
              color: #7f7f7f;
            }
            .total-pcs {
              color: #307bff;
            }
          }
          .quantity-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            margin-bottom: 5px;
            .title {
              width: 186px;
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
          /deep/.van-checkbox {
            .van-checkbox__label {
              margin-left: 3px;
            }
            .van-checkbox__icon {
              height: auto;
            }
          }
        }
      }
      .is-Direct {
        .quantity-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          margin-bottom: 5px;
          .title {
            width: 186px;
            &::before {
              content: '#';
              width: 8px;
              height: 8px;
              color: #307bff;
              margin-right: 5px;
            }
          }
        }
        .custom-quantity-item {
          .title {
            &::before {
              color: #808000;
            }
          }
        }
        /deep/.van-collapse {
          .van-collapse-item__title {
            padding: 0;
            font-size: 12px;
            background-color: #f7f7f7;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            margin-bottom: 0;
          }
          .van-collapse-item__title--expanded::after {
            display: none;
          }
          .van-collapse-item__content {
            padding: 10px;
            font-size: 12px;
            background-color: #f7f7f7;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }
          .van-cell__right-icon {
            right: 10px;
            top: 2px;
          }
        }
        /deep/.van-hairline--top-bottom::after {
          display: none;
        }
      }
      .stepper-custom {
        display: flex;
        align-items: center;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        overflow: hidden;
        .step-btn {
          width: 28px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          color: #333333;
          cursor: pointer;
          border-right: 1px solid #b9cbed;;
          font-size: 12px;
          &:last-child {
            border-right: none;
          }
          &:active {
            background-color: #f2f3f5;
          }
        }
        .step-value {
          width: 32px;
          height: 24px;
          padding: 0;
          background-color: #fff;
          border-right: 1px solid #b9cbed;
          border-radius: 0;
          /deep/ .van-field__control {
            text-align: center;
            height: 24px;
            line-height: 24px;
            color: #323233;
            font-size: 12px;
          }
        }
      }
      /deep/.van-uploader {
        .van-uploader__upload {
          width: 60px;
          height: 60px;
        }
        .van-uploader__preview-image {
          width: 60px;
          height: 60px;
        }
      }
      .select-field {
        display: flex;
        align-items: center;
        min-height: 36px;
        color: #333;
      }
    }
    .listing-form-item {
      padding-bottom: 10px;
      margin-bottom: 26px;
      border-bottom: 3px solid #e8effc;
      .shelf-radio {
        .van-radio-group {
          flex-direction: column;
          .van-radio {
            margin-bottom: 5px;
            font-weight: bold;
          }
        }
      }
    }
    .no-listing-form-item {
      border-bottom: none;
    }
    .shelf-title {
      font-size: 13px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }
    .shelf-bc {
      padding: 10px 0;
      background-color: rgba(228, 231, 235, .3);
      .form-item:last-child {
        margin-bottom: 0px;
      }
    }
    .product-title {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      color: #333;
      border-bottom: 1px solid #e8effc;
      margin-bottom: 10px;
      font-size: 13px;
      .left-desc {
        flex: 1;
        font-weight: bold;
      }
      &.square {
        &::before {
          content: '';
          width: 8px;
          height: 8px;
          background-color: #307bff;
          // position: absolute;
          // left: 0;
          // top: 0;
          transform: rotate(45deg);
          margin-right: 5px;
        }
      }
    }
    .sub-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0;
      border-bottom: 1px solid #e8effc;
      font-size: 12px;
      margin-bottom: 10px;
      .total-right {
        color: #333;
      }
    }
    .top-title {
      display: flex;
      font-weight: bold;
      color: #000;
      font-size: 12px;
      .ell-icon {
        margin-top: 2px;
        width: 11px;
        height: 11px;
        margin-right: 5px;
      }
    }
    .uploader-customer {
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      .label {
        align-self: flex-start;
      }
    }
    .sell-in-quantity {
      margin-bottom: 43px;
    }
    .form-time-item {
      display: flex;
      align-items: center;
      padding: 0 10px;
      margin-top: 10px;
      .label {
        margin-right: 10px;
        margin-bottom: 0;
      }
      .custom-field {
        flex: 1;
      }
    }
    .add-more {
      display: inline-block;
      padding: 5px;
      font-size: 12px;
      color: #307bff;
      border: 1px solid #307bff;
      background-color: #e4eefc;
      border-radius: 6px;
      margin-bottom: 10px;
    }
    .custom-add-more {
      color: #808000;
      border: 1px solid #808000;
      background-color: #ECECD4;
    }
    // .custom-label {
    //   display: flex;
    //   align-items: center;
    //   .label-icon {
    //     width: 16px;
    //     height: 16px;
    //     margin-left: 3px;
    //   }
    // }
    .psi-section {
      margin: 10px;
      margin-top: 0;
      padding: 50px 60px;
      text-align: center;
      background-color: #f7f7f7;
      border-radius: 10px;
      color: #333;
      font-size: 12px;
    }
    .sample-delivry,
    .material-delivery {
      color: #333;
      margin-bottom: 10px;
      .main-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        border-top: 1px solid #e8effc;
        border-bottom: 2px solid #e8effc;
        font-size: 12px;
        .total-num {
          font-size: 14px;
          font-weight: bold;
          color: #307bff;
        }
        &:first-child {
          border-top: none;
        }
      }
      .sell-out-btn {
        height: 23px;
        line-height: 23px;
        padding: 0px 3px;
        background-color: #e8effc;
        border-radius: 5px;
        font-size: 11px;
        border: 1px solid #307bff;
        color: #307bff;
      }
      .promotion-item {
        display: flex;
        padding: 10px 6px;
        border-bottom: 1px solid #b9cbed;
        font-size: 12px;
        .right-content {
          flex: 1;
          display: flex;
          align-items: center;
        }
        .icon-img {
          width: 45px;
          height: 45px;
          margin-right: 5px;
          object-fit: contain;
        }
        .info-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 40px;
          .product-info {
            display: flex;
            align-items: center;
          }
          .product-name {
            max-width: 136px;
            font-size: 13px;
          }
          .material-inventory {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .product-name-item {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            }
            .project-name {
              padding: 1px 3px;
              border: 1px solid #307bff;
              color: #307bff;
              margin-right: 3px;
              margin-bottom: 3px;
              font-size: 10px;
            }
            .universal-name {
              border: 1px solid #34b032;
              color: #34b032;
            }
            .inventory-num {
              flex: 1;
            }
          }
        }
        .stepper-custom {
          display: flex;
          align-items: center;
          border: 1px solid #b9cbed;
          border-radius: 4px;
          overflow: hidden;
          .step-btn {
            width: 28px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            color: #323233;
            cursor: pointer;
            border-right: 1px solid #b9cbed;;
            font-size: 12px;
            &:last-child {
              border-right: none;
            }
            &:active {
              background-color: #f2f3f5;
            }
          }
          .step-value {
            width: 32px;
            height: 24px;
            padding: 0;
            background-color: #fff;
            border-right: 1px solid #b9cbed;
            border-radius: 0;
            /deep/ .van-field__control {
              text-align: center;
              height: 24px;
              line-height: 24px;
              color: #323233;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .visit-btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    .submit-btn {
      width: 100%;
      background-color: #307bff;
      color: #fff;
      font-weight: bold;
    }
  }
  .pcs-num {
    color: #307bff;
    font-weight: bold;
  }
}

.collapse-title-reuqired {
  color: #ff4444;
  margin-right: 5px;
}
</style>
